<template>
    <div class="page-wrapper" ref="dw">
        <!-- 顶部图片 -->
        <div class="movie-box banner-wrapper">
            <img class="page-image" src="@assets/images/child-banner-top.png" />
        </div>

        <div class="movie-box festivalList-wrapper">
        <!-- nav -->
        <div class="movie-box acea-row row-middle nav-wrapper" ref="nav">
            <FestivalNav v-if="!mounting" @checkNav="checkNav" :isless="true" :boxStyle="boxStyle" :liStyle="liStyle" :current="current" :navList="navList"></FestivalNav>
        </div>
        
        <div class="movie-box acea-row row-middle nav-wrapper mounting" v-show="mounting">
            <FestivalNav @checkNav="checkNav" :isless="true" :boxStyle="boxStyle" :liStyle="liStyle" :current="current" :navList="navList"></FestivalNav>
        </div>
        
        
        <!-- 模板 -->
        <div class="movie-box" v-for="(item, ind) in list" :key="ind" :ref="'modul'+item.id">
            <FestivalModul :cardStyle="cardStyle" :bottomPrice="bottomPrice" :cardOne="cardOne" :titleInfo="item.titleInfo" :listWrapStyle="listWrapStyle" :imgStyle="imgStyle" :listStyle="listStyle" :festivalName="festivalName" :list="item.list"></FestivalModul>
        </div>

        <!-- 底部图片 -->
        <div class="movie-box page-relative" @click="goToTop">
            <img class="page-image" src="@assets/images/child-banner-bot.png" />
            <div class="page-absolute gowrap">
                <img class="goTop" @click="goToTop" src="@assets/images/child-goTop.png" />
                <img class="goHome" @click="goBack" src="@assets/images/child-goHome.png" />
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import FestivalModul from "@components/FestivalModul.vue";
import FestivalNav from "@components/FestivalNav.vue";
import debounce from "lodash.debounce";
export default {
    name: "FestivalList",
    components: {
        FestivalModul,
        FestivalNav
    },
    data: function () {
        return {
            mounting: false,
            festivalName: 1,
            listStyle: {
                background: `url(${require('@assets/images/child-bgd-m.png')}) no-repeat`,
                "background-size":"100% 100%",
                padding:"0.4rem",
                overflowX: "initial",
                "border-radius": "0.6rem"
            },
            listWrapStyle: {
                marginTop: "-0.02rem",
                overflowX: "auto"
            },
            cardStyle: {
                "min-height": "4.5rem"
            },
            boxStyle: {
                "justify-content": "center"
            },
            liStyle: {
                width: "1.7rem",
                margin: "0 0.02rem"
            },
            cardOne: {
                "border-radius": "0.3rem"
            },
            bottomPrice: {
                dd: {
                    "align-items": "center"
                }
            },
            imgStyle: {
                "height": "2.4rem",
                margin: "0.4rem 0 0.6rem"
            },
            navList: [
                {
                    id: 1,
                    img: require("@assets/images/child-nav1.png"),
                    checkImg: require("@assets/images/child-navc1.png")
                }, {
                    id: 2,
                    img: require("@assets/images/child-nav2.png"),
                    checkImg: require("@assets/images/child-navc2.png")
                }, {
                    id: 3,
                    img: require("@assets/images/child-nav3.png"),
                    checkImg: require("@assets/images/child-navc3.png")
                }, {
                    id: 4,
                    img: require("@assets/images/child-nav4.png"),
                    checkImg: require("@assets/images/child-navc4.png")
                }
            ],
            list: [
                {
                    id: 1,
                    titleInfo: require("@assets/images/child-title1.png"),
                    list: [
                    {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/8a4dbe48a4fe275dd9b3cf0f9ca941e1.jpg",
                        title: "babycare儿童餐具5件套BC2008039",
                        price: 97.00,
                        id: 177790
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/cb3cd646254f355035e1dcee2f590957.jpg",
                        title: "babycare儿童推车（便携式可折叠伞车）BC2012026",
                        price: 257.00,
                        id: 177793
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210521/6fb11b4842785605808ef880f5c56003.jpg",
                        title: "Babycare 婴儿背带（颜色随机）",
                        price: 241.00,
                        id: 7020
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/6afdfcca5a6dde1883fbfdd30df20859.jpg",
                        title: "露安适 幼嫩安敏润肤露80g",
                        price: 86.00,
                        id: 178670
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/880f26a2584dca7dd61c6ffac91dde65.jpg",
                        title: "babycare带帽浴巾QFQ001-95A",
                        price: 107.00,
                        id: 177809
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/e309bc49272dfe3f8d966e69c3c66224.jpg",
                        title: "日本Wakodo和光堂 儿童洗发液 450ml",
                        price: 76.00,
                        id: 177814
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/33036dc56c8c860bf62aeefdced7fcb3.jpg",
                        title: "日本贝亲Pigeon母乳实感PPSU奶瓶 米奇160ml",
                        price: 105.00,
                        id: 177821
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/d9eadc0e120a49ab174956fdd3644ae3.jpg",
                        title: "贝亲　婴儿润肤护肤油按摩　80mL",
                        price: 36.00,
                        id: 177822
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/ee978a40e9ec43f0c771d163c0d37a68.jpg",
                        title: "日本贝亲pigeon耐热玻璃阔口奶瓶绿色 240ML",
                        price: 120.00,
                        id: 177825
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/b7d417928be3a43d7c33840d443dc917.jpg",
                        title: "日本Pigeon贝亲液体新生去痱子粉桃叶水 200mlx2",
                        price: 78.00,
                        id: 177823
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/d7292e22376cf705ce7a43cbbd32bf50.jpg",
                        title: "日本Pigeon贝亲固体痱子粉植物保湿爽身粉 45g",
                        price: 39.00,
                        id: 177824
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/4a11b866acf5d833801b4e805284a574.jpg",
                        title: "露安适 甜睡新生低泡洗发沐浴露400ml",
                        price: 116.00,
                        id: 178671
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/79aac38e94eb27ecd9cf37899fa490dc.jpg",
                        title: "全棉时代 袋装婴儿棉柔巾80片/包x6包",
                        price: 118.00,
                        id: 178673
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/ef655682ffbae7bbc98278982bd2bbd5.jpg",
                        title: "全棉时代 圆筒细纸棒婴儿棉签200支/筒x4筒",
                        price: 35.00,
                        id: 178676
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/9eccb80e62b1fce38bb92d57da740c2e.jpg",
                        title: "露安适 婴儿乐享甜睡纸尿裤NB/30片x2",
                        price: 178.00,
                        id: 178678
                    }, {
                        image: "https://image.dongfangfuli.com/mall/upload/image_temp/2020-05/1e8a2bf4-b075-474c-9985-93d651d25e42.jpg",
                        title: "艾惟诺（Aveeno）婴儿每日倍护润肤乳 无香型 354ml/瓶 单瓶装",
                        price: 94.00,
                        id: 6342
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/f14db4568a02e9d9b8917ce179f68f88.jpg",
                        title: "艾惟诺婴儿舒缓柔嫩沐浴乳 236ml 4820611202",
                        price: 79.00,
                        id: 177844
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/15468c6c91f8afe025ac59c548ddeba0.jpg",
                        title: "强生 婴儿保湿润肤露200毫升",
                        price: 41.90,
                        id: 178681
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/ca5e40e47b964e4d8aa697e09450b8cb.jpg",
                        title: "费雪(Fisher-Price) 婴幼儿玩具3-6-12个月新生儿健身器-脚踏钢琴健身架（薄荷绿）GDL83",
                        price: 309.00,
                        id: 177848
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/d116dec88d0449e783069cd43c72180f.jpg",
                        title: "费雪(Fisher Price)缤纷动物尾巴布书 幼儿3D立体手偶布书手掌书婴儿早教启蒙玩具0-2岁F0850",
                        price: 62.00,
                        id: 177850
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/0d654d4fdbbd381f678695be02202a40.jpg",
                        title: "费雪(Fisher-Price)6本布书套装 宝宝布书幼儿早教婴儿童学习玩具0-2岁数字动物形状视觉F0812生日礼物礼品",
                        price: 69.00,
                        id: 177845
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/bb4f502832440d64bb42d723ea073038.jpg",
                        title: "费雪(Fisher-Price) 婴儿床铃宝宝玩具0-1岁哄睡神器婴儿安抚摇铃-3合1海马安抚床铃DFP12",
                        price: 189.00,
                        id: 177852
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/52f323c6dc25925da4e0b79f9118f464.jpg",
                        title: "澳贝（AUBY）婴儿童玩具电子多功能学习桌学步车宝宝手推车助步车音乐电子琴461542男孩女宝生日礼物礼盒",
                        price: 199.00,
                        id: 177853
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/c0ee0e89b5328de6a496905e5108e9ed.jpg",
                        title: "澳贝（AUBY）婴儿童玩具男孩女孩欢乐爬行小象2档调速声控触发爬行趣味游戏（新旧配色随机发货）",
                        price: 134.00,
                        id: 177854
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/f182b675bed5367185cb1312e84b39bb.jpg",
                        title: "费雪(Fisher-Price) 小火车儿童玩具礼物数字启蒙学习早教益智玩具-小贝贝学习火车 GGC28",
                        price: 339.00,
                        id: 177851
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/56dc8eb9b96f7a95cdf376377f857741.jpg",
                        title: "澳贝（AUBY）婴儿童玩具男孩女孩宝宝探索电子锤婴幼儿童声光敲打男孩女孩（新旧配色随机发货）生日礼物",
                        price: 138.00,
                        id: 177855
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/61754a356c0c00bcf5cf34aad2b6f775.jpg",
                        title: "全棉时代 抗菌除螨洗衣液 1kgx3",
                        price: 85.00,
                        id: 178682
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/47bd2613d44a0432deaa76ed5b4e3feb.jpg",
                        title: "日本花王KAO 防蛀补钙护齿木糖醇儿童牙膏 哈密瓜味 70gx3",
                        price: 50.00,
                        id: 177828
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/53acf4b02671619fe4eabf6128ecb9ef.jpg",
                        title: "日本 三芳儿童泡沫洗面奶 250ml",
                        price: 55.00,
                        id: 177829
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/f9042474680a5efe38e2096644fc63ef.jpg",
                        title: "日本sunstar巧虎 儿童牙刷 0-2岁 4只装",
                        price: 66.00,
                        id: 178697
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/1892c040eb72f7900a6be16b9e3e4b78.jpg",
                        title: "DeRU丹之荣 3D儿童口罩0-3岁男（10枚）盒装",
                        price: 29.00,
                        id: 178683
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/40dd0900e996c809e9527f736a905c5c.jpg",
                        title: "全棉时代 袋装纱布汗巾3条",
                        price: 86.00,
                        id: 178684
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/75dee64c1d77ef4b195819b9a5d88dd2.jpg",
                        title: "谷雨游戏桌多功能学习桌儿童婴儿玩具男孩女孩早教机新生儿幼儿一岁宝宝1-3-6岁礼物 谷雨游戏桌",
                        price: 188.00,
                        id: 177856
                    }  
                    ]
                }, {
                    id: 2,
                    titleInfo: require("@assets/images/child-title2.png"),
                    list: [
                        {
                            image: "https://image.dongfangfuli.com/mall/upload/image_temp/2020-05/894b83e0-67fe-4f9a-9119-94d8a51bce52.jpg",
                            title: "哆啦A梦 毛浴巾三件套礼盒 100%全棉 方巾毛巾浴巾 DM-12215",
                            price: 89.00,
                            id: 5294
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/2342de314ee9f64840b0f1126de079c1.jpg",
                            title: "日本 EBISU/惠百施 儿童牙刷 2-6岁 hello kitty 3只装",
                            price: 45.00,
                            id: 178691
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/7d46f77cf815946a6d3cbc3989dcd995.jpg",
                            title: "日本 BabySmile 电动牙刷 S-204P粉色",
                            price: 125.00,
                            id: 177816
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/46a892212b90684c4d4879bd6f494551.jpg",
                            title: "日本 BabySmile 电动牙刷 S-204B蓝色",
                            price: 125.00,
                            id: 177817
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/8d112defa8179b50c127d87c76f15aa9.jpg",
                            title: "贝亲 Pigeon 婴儿润唇啫喱润唇膏 7g",
                            price: 37.00,
                            id: 177818
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/c3a776283dee0372915f95a261de6074.jpg",
                            title: "日本贝亲Pigeon婴儿专用衣物洗衣液 800ML",
                            price: 40.00,
                            id: 177819
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/444c3c56f3f87e7d2d70536deb5d9310.jpg",
                            title: "日本 狮王Check-up儿童牙膏60g苹果味x2",
                            price: 55.00,
                            id: 177820
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/9c293392838a9d41853a0d8794ab9fd2.jpg",
                            title: "日本狮王LION 面包超人儿童牙膏 婴幼儿防龋齿可吞安全草莓味 40gx3",
                            price: 45.00,
                            id: 177827
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/5512f1786fa9ab92b87f2ab886a7d8af.jpg",
                            title: "babycare儿童电动理发器DHB006-A",
                            price: 145.00,
                            id: 18052
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/1755436ed9e2e3e004687fc91a0d101e.jpg",
                            title: "费雪(Fisher-Price) 儿童玩具男孩女孩数字形状颜色学习早教益智玩具-探索学习六面盒CMY28",
                            price: 185.00,
                            id: 177847
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/98c052fd13a071bc9edf739fa4781513.jpg",
                            title: "babycare婴儿防摔枕５１６６",
                            price: 89.00,
                            id: 177996
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/569689f17f4d0e05411ef75e391fecaf.jpg",
                            title: "日本 膳魔师 儿童双耳保温杯-蓝色",
                            price: 238.00,
                            id: 177811
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/45189761d5499c6a7c3a4fa07104877d.jpg",
                            title: "日本 ZOJIRUSHI/象印 儿童保温杯 红胖子450ml",
                            price: 283.00,
                            id: 177812
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/ddef5e2b9d781bae40892a63afe461de.jpg",
                            title: "日本 tiger/虎牌 保温杯日本本土版 兔仔 600ml",
                            price: 336.00,
                            id: 177813
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/31ac3ab64c2e6995d51197dbfc613b4a.jpg",
                            title: "日本 LION/狮王儿童漱口水米奇 葡萄味 250ml",
                            price: 35.00,
                            id: 177826
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/082fa39bebe9262994eedf08f7b37e1e.jpg",
                            title: "日本Wakodo和光堂 驱蚊贴 60枚/包",
                            price: 64.00,
                            id: 177815
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/7d0bc7746a5bfd5712e999079f98f3b3.jpg",
                            title: "日本sunstar巧虎 儿童牙刷 2-4岁 4只装",
                            price: 66.00,
                            id: 178692
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/f27a5c6f4904c64a86e18afa323bef6a.jpg",
                            title: "日本sunstar巧虎 儿童牙刷 4-6岁 4只装",
                            price: 66.00,
                            id: 178693
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/d0d5a35cb54dede6a2600fe5ca024134.jpg",
                            title: "全棉时代 婴儿口手湿巾，15X20cm， 25片x4袋/套",
                            price: 39.90,
                            id: 178694
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/cdc14a7acba98cb2a73b1b4dc6bc76b4.jpg",
                            title: "babycare儿童坐便器8010",
                            price: 128.00,
                            id: 177860
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/46fb4aea0bfefecf9abd131788f0e8f4.jpg",
                            title: "费雪Fisher•Price球池围栏（内配25个海洋球）",
                            price: 138.00,
                            id: 20023
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/5ffc7dd7e49a437bbec73928eed8ea57.jpg",
                            title: "AIrud小飞侠儿童三轮脚踏手推车HB-AMS02",
                            price: 151.00,
                            id: 177954
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/c895c72abb1e2175918558dba1d2d0d8.jpg",
                            title: "咪咪兔趣味龙小闹钟HH4",
                            price: 116.00,
                            id: 177857
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/e53953ff1be100c546d0ba02455bb0e2.jpg",
                            title: "咪咪兔儿童话筒淘气兔款",
                            price: 164.00,
                            id: 177858
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/d653f9be8ab0310e7c4f324d46f7c713.jpg",
                            title: "哆啦A梦 闪光三轮滑板车DM-8027",
                            price: 219.00,
                            id: 20104
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/886c2f267c0873ab29b57637af14ac99.jpg",
                            title: "Apiyoo泰迪系列 儿童声波电动牙刷U型",
                            price: 150.00,
                            id: 177881
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/08790365a9ad78a3af37a1e645863f0f.jpg",
                            title: "babycare趣味儿童扭扭车7929",
                            price: 299.00,
                            id: 177883
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/117fc59b023b4686669607ac883c9b03.jpg",
                            title: "MOBBE手指画（12色)P010T12",
                            price: 70.00,
                            id: 177949
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/477c549b767e5acda6d8a11e2186fd24.jpg",
                            title: "MOBBE蘑菇钉礼盒T002",
                            price: 89.00,
                            id: 177948
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/3c69c6459cf9adc3edb2613ae6ffbc9e.jpg",
                            title: "MOBBE甲骨文T009B",
                            price: 74.00,
                            id: 177947
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/1d771f8c10610d4e6b978e6ca9eb5056.jpg",
                            title: "MOBBE橙色木制礼盒 （活力橙多功能画板款）P019T1",
                            price: 264.00,
                            id: 177946
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/24306706650e081040549c5323252739.jpg",
                            title: "MOBBE二次元书包简约款G001-1",
                            price: 214.00,
                            id: 177945
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b9ac7307f8f2857e6a2f24a5893d1f04.jpg",
                            title: "MOBBE马丁包G002",
                            price: 260.00,
                            id: 177944
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/18ca383511b1e3fbb178031590d5a9b4.jpg",
                            title: "当童话精粹遇见艺术巨匠-致敬大师、细数经典，礼盒装（全25册）[3-6岁]",
                            price: 244.00,
                            id: 177940
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/5c048553b967a82c4f0028c6c16cd6cd.jpg",
                            title: "当童话精粹遇见艺术巨匠-全球顶尖绘本大师传世佳作-用爱启迪（全29册）[3-6岁]",
                            price: 278.00,
                            id: 177932
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/6ca3e0201a686cf62b13d838634971fd.jpg",
                            title: "0-4岁幼儿认知翻翻书·数字 0-4岁幼儿认知翻翻书·动物 两册",
                            price: 79.00,
                            id: 177969
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/506bddb7b25ada8cfa9359e6c6325f23.jpg",
                            title: "《四五快数》（全7册+40集游戏教学视频）[3-6岁]",
                            price: 197.00,
                            id: 177930
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/646897b6f7f411e1b8c418592508696e.jpg",
                            title: "宫西达也 你看起来好像很好吃 教师推荐书单 恐龙套装简装7册 3-6岁 蒲蒲兰绘本",
                            price: 109.00,
                            id: 177927
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/ba5916297d8d28a7fd49ceb38826f153.jpg",
                            title: "小猪佩奇我有好习惯:行为引导系列（套装10册）10个幼儿必备好习惯，洗澡也能看的书。[3-6岁]",
                            price: 90.00,
                            id: 177923
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/565fc6336af299f1589aaf231f4309be.jpg",
                            title: "迪士尼金色童年绘本珍藏馆 童趣出品[3—6岁]",
                            price: 341.00,
                            id: 177920
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b7f062dda65b4e8d6115368bedad2d69.jpg",
                            title: "奇先生妙小姐 全新故事绘本礼盒：好性格+好行为+好习惯（3-6岁 24册套装 扫码听故事音频+69张贴纸+成长自律表）",
                            price: 157.00,
                            id: 177918
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/47a79aa32752b03bea37a4dfdd72a6ae.jpg",
                            title: "AR魔幻互动百科恐龙立体书：龙藏（AR场景 3D立体 附赠10张科普知识卡）3-6岁亲子互动 7-10岁自主阅读[7-10岁]",
                            price: 111.00,
                            id: 177914
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/e3a87d0ef57c6f061fb6dfe7bf3f76ab.jpg",
                            title: "5分钟专注力训练迷宫：益智迷宫游戏300个（套装3册）6大迷宫种类+6大能力提升 3-6岁",
                            price: 99.00,
                            id: 177910
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/53ac3694032e9418e8847ec625ff05cb.jpg",
                            title: "乐乐趣儿童科普书 《我们的身体》 幼儿启蒙绘本 互动好玩人体百科立体书 适合3-6岁",
                            price: 103.00,
                            id: 177907
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/e428391a5e36af2e00622e3a89ac704b.jpg",
                            title: "我爸爸+我妈妈+我喜欢自己（套装全3册）[3-9岁]",
                            price: 93.00,
                            id: 177925
                        }
                    ]
                }, {
                    id: 3,
                    titleInfo: require("@assets/images/child-title3.png"),
                    list: [
                        {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/8022e92f12fc73f546e94fefa31dd905.jpg",
                            title: "日本 EBISU/惠百施 儿童牙刷 6-12岁 多啦A梦 3只装",
                            price: 45.00,
                            id: 178695
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/546495c42b21b359d45bcafa9fa556a7.jpg",
                            title: "日本sunstar巧虎 儿童牙刷6-12岁 4只装",
                            price: 66.00,
                            id: 178696
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/63c6e28d77395d801ee78ac6dd5b9a85.jpg",
                            title: "翻译笔 阿尔法蛋词典笔Q3",
                            price: 589.00,
                            id: 177878
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/f63a26ac5679e852d3f74bdc125b19b1.jpg",
                            title: "米兔儿童电话手表5C",
                            price: 399.00,
                            id: 177880
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/f2277c1e7d0aeff90c495bb8adccdf18.jpg",
                            title: "华为儿童手表 3X",
                            price: 888.00,
                            id: 177879
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/5008/40708/img300.jpg",
                            title: "外交官（Diplomat）BB-L3301 拉杆箱（布布儿童系列）",
                            price: 268.00,
                            id: 173053
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/5009/40709/img300.jpg",
                            title: "外交官（Diplomat）BB-S3203 双肩包（布布儿童系列）",
                            price: 108.00,
                            id: 173054
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/5010/40710/img300.jpg",
                            title: "外交官（Diplomat）BB-S3201 双肩包（布布儿童系列）",
                            price: 98.00,
                            id: 173055
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/5011/40711/img300.jpg",
                            title: "外交官（Diplomat）BB-S3202 斜挎包（布布儿童系列）",
                            price: 85.00,
                            id: 173056
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/6887/58907/img300.jpg",
                            title: "哆啦A梦(DORAEMON)DM-1694 保温杯300ml",
                            price: 78.00,
                            id: 174428
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-03/fa701f0d186401c7b9c1c784bdb8d574.jpg",
                            title: "哆啦A梦 保温杯 DM-1699 蓝色",
                            price: 98.00,
                            id: 14232
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/f264792c439ea1eae72cbe119c5b42b5.jpg",
                            title: "万代泽塔升华器变身套装（中文版）57617",
                            price: 365.00,
                            id: 177884
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/a9aa0c2536ea43023f6595559a13c692.jpg",
                            title: "万代DX胜利神光棒58777",
                            price: 392.00,
                            id: 177885
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/da9bd4a6e254196ae3a80c8df27d2166.jpg",
                            title: "万代奥特英雄系列 特利迦奥特曼 强力型64543",
                            price: 54.00,
                            id: 177886
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/aa69101ace45c9b2cbd62f6e80446da4.jpg",
                            title: "万代奥特英雄系列 特利迦奥特曼 空中型64544",
                            price: 54.00,
                            id: 177887
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/658ab429bf5b8aff4a853ecfb51c127d.jpg",
                            title: "万代奥特英雄系列 闪耀迪迦64622",
                            price: 54.00,
                            id: 177888
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/7c17b76aec5aad270e3d56fc0adb875f.jpg",
                            title: "万代17.5厘米发声超可动捷德奥特曼机敏形态67714",
                            price: 91.00,
                            id: 177889
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/4c8bd489db559a933e49f2319106f9d2.jpg",
                            title: "万代17.5厘米发声超可动欧布奥特曼 欧布原67716",
                            price: 91.00,
                            id: 177890
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/29e8fa8a655dd07622c2ed26ca13412f.jpg",
                            title: "万代特利迦奥特曼-胜利神光棒68777",
                            price: 301.00,
                            id: 177891
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/1c4f33d8935b74b53e67820a6146d043.jpg",
                            title: "万代特利迦奥特曼复合型超决战卡露蜜拉69056",
                            price: 91.00,
                            id: 177892
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b79e866edf8bb8e5773acf509652209c.jpg",
                            title: "万代特利迦奥特曼强力型超决战达阿贡69057",
                            price: 91.00,
                            id: 177893
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/48c280509f411c04f1f524bc98a96eb9.jpg",
                            title: "万代特利迦奥特曼空中型超决战希多拉姆69058",
                            price: 91.00,
                            id: 177894
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b5e55fb1155380c501d450db26531536.jpg",
                            title: "万代欧布奥特曼原生初始形态超决战哥尔巴69059",
                            price: 91.00,
                            id: 177895
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/a8712d280e14a6369accb215a4ca489d.jpg",
                            title: "万代高斯奥特曼日蚀形态超决战加佐特69060",
                            price: 91.00,
                            id: 177896
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/5874f48bc0d9693b6d59a13f075f301b.jpg",
                            title: "万代永恒闪耀特利迦超决战黑暗特利迦69061",
                            price: 91.00,
                            id: 177897
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/4ac14041c92674eec3d8e926ee76e196.jpg",
                            title: "万代利布特奥特曼超决战迪亚波罗69062",
                            price: 91.00,
                            id: 177898
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b4ad76fd79c0217878cb347d802f4734.jpg",
                            title: "万代欧布奥特曼三重形态超决战戴亚伯里克69063",
                            price: 91.00,
                            id: 177899
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/0562c5739ac438c8cb540dd2667f1458.jpg",
                            title: "杰的机甲71740",
                            price: 182.00,
                            id: 177956
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/8d6283ffa43b1b048c915e0d2694b40e.jpg",
                            title: "乐高经典创意中号积木盒10696",
                            price: 319.00,
                            id: 177901
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/f5f8122c4d3afd35bc63c7c882553ac4.jpg",
                            title: "乐高经典创意小号积木盒10692",
                            price: 155.00,
                            id: 177900
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/bd169411db100d8f378745a056ed54eb.jpg",
                            title: "百变超能蜗牛30563",
                            price: 45.00,
                            id: 177988
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/86479e16c76fcda2e6bab16ae6454445.jpg",
                            title: "乐高奖杯40385",
                            price: 118.00,
                            id: 177902
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/25e42cd32d62cf550234404aa8ad9604.jpg",
                            title: "生日小熊30582",
                            price: 45.00,
                            id: 177986
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/7355f277b432695f13972fc9987f838e.jpg",
                            title: "德国牧羊犬40440",
                            price: 136.00,
                            id: 177979
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/ae3b08e4b7152f4e25bd5aa21d29a5ea.jpg",
                            title: "郁金香40461",
                            price: 91.00,
                            id: 177904
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/9c842a11d8e60ab1629024f77952bde1.jpg",
                            title: "嘟嘟车40469",
                            price: 91.00,
                            id: 177978
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/9c3709cdbb9148410a541d2d113874d1.jpg",
                            title: "黄蜂牌小摩托40517",
                            price: 91.00,
                            id: 177975
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/4c46a8036bfe3ee175f3b79f1cf4139f.jpg",
                            title: "奥莉薇亚的爱心藏宝盒41357",
                            price: 72.00,
                            id: 177973
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b664606bc0f01b68e1702f82ee67e530.jpg",
                            title: "游戏玩家手环41943",
                            price: 54.00,
                            id: 177958
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/24eb7e5da7ef5b7350cfb2b53daa02c0.jpg",
                            title: "逃亡卡车42090",
                            price: 209.00,
                            id: 177957
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/df43976939504ddf7db005ba7f1e68b4.jpg",
                            title: "凯威 0100儿童羽毛球拍双拍2支",
                            price: 58.00,
                            id: 178698
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/eee7cfa5dd7e6cf8b8ed956a57804a57.jpg",
                            title: "沸点BOILING播零 滑板初学者儿童滑板双翘板滑板车四轮青少年滑板【5~10岁儿童滑板】 和平ET",
                            price: 396.00,
                            id: 178699
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/4a2912b1bb288b1bf14542e8f31dd53b.jpg",
                            title: "AIrud超级英雄儿童滑步平衡车 HB-AWH07",
                            price: 264.00,
                            id: 177955
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/3ac0ea266542438eb365b180422c387d.jpg",
                            title: "AIrud吉普儿童电动越野车儿童电动车",
                            price: 399.00,
                            id: 177953
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/d5b7a58b5e1e3d51b59bbae591966139.jpg",
                            title: "AIrud电动摩托车三轮车",
                            price: 450.00,
                            id: 177952
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/e520ca6837856d99fe006140b9449c2c.jpg",
                            title: "MOBBE丝滑蜡笔桶装36色P001T36",
                            price: 97.00,
                            id: 177951
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220523/e8ba11a3b5d6fea3e100c2d3c58d8580.jpg",
                            title: "MOBEE 玩具蜡笔（幸运蛋）P002D",
                            price: 31.00,
                            id: 178703
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/aec560ae9c089a4ee51c7be38c694c42.jpg",
                            title: "MOBBE七彩纽扣贴画礼盒M006",
                            price: 41.00,
                            id: 177950
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220523/67a4f670904d0acf62bd8dd592e168aa.jpg",
                            title: "MOBEE 手指画（6色）P010T6",
                            price: 54.00,
                            id: 178702
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/1376ec4094abf032386ebf1aa689db6d.jpg",
                            title: "MOBBE行李箱C003B",
                            price: 294.00,
                            id: 177943
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/a5201b9846838e85e9573c0a51250d4c.jpg",
                            title: "迪士尼·柔肤棉四件套DJM20-2023C",
                            price: 169.00,
                            id: 177942
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/95539b3556f7dd40d03a1a416f0f2f51.jpg",
                            title: "迪士尼·有氧亲肤水洗被货 号： DXM12-1520B",
                            price: 140.00,
                            id: 177941
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/4218fbe08e637c08251c0a3450c764e1.jpg",
                            title: "1分钟儿童小百科：多彩文化+各行各业套装（全6册）软包精装、环保印刷、有声伴读、拼音标注 [3-10岁]",
                            price: 188.00,
                            id: 177963
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/d3323306d671b43514d8b3ba6a3d9ed9.jpg",
                            title: "漫画儿童心理百科-我知道我该怎么办了（套装共5册）[6-12岁]",
                            price: 155.00,
                            id: 177916
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/57b3a272fe06b215dd10b0110a79f4b5.jpg",
                            title: "到有繁星的地方去：火箭设计师给孩子的立体书 [5-12岁]",
                            price: 151.00,
                            id: 177915
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/89eb5930fa7ce22819770456fad7a4f2.jpg",
                            title: "这就是物理（函套10册） [3-12岁]",
                            price: 168.00,
                            id: 177912
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/08b9a778a29f99f6554b3ca0eab3922b.jpg",
                            title: "十万个为什么彩图注音版（礼盒精装 套装10本）",
                            price: 93.00,
                            id: 177961
                        }
                    ]
                }, {
                    id: 4,
                    titleInfo: require("@assets/images/child-title4.png"),
                    list: [
                    {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/64a5c879745dc47e93e6cf51b7106c62.jpg",
                        title: "胡桃夹子40425",
                        price: 91.00,
                        id: 177903
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/db12949e351bb0100e220b5bf6504547.jpg",
                        title: "驯鹿与圣诞精灵40353",
                        price: 182.00,
                        id: 177983
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/e4eaeb4c8b3ad1ab14688f64c9d37a03.jpg",
                        title: "唐老鸭40377",
                        price: 99.00,
                        id: 177981
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/1247e9c30c4d6672cb48b39436e783a3.jpg",
                        title: "华为智选 欧普智能护眼台灯pro MT615-D20WTT",
                        price: 389.00,
                        id: 177877
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/ccde187720e85c43995a3656b50bb006.jpg",
                        title: "babycare吸入式灭蚊灯DQA005-A",
                        price: 186.00,
                        id: 177882
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/0ce18b06c37fbe46c332695845f98e7c.jpg",
                        title: "李宁（LI-NING） 时尚系列夜光吸湿室内外7号篮球 LBQK290-3",
                        price: 169.00,
                        id: 178700
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220521/1cb2df9606072ebaa4681a8dc3d90d98.jpg",
                        title: "李宁（LI-NING）足球儿童中小学生青少年训练比赛耐磨足球 4号机缝足球 639-3",
                        price: 88.00,
                        id: 178701
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/e574647f01e9fc503ee3850656a15a79.jpg",
                        title: "5分钟专注力训练 让孩子越玩越聪明的2100个思维游戏（全8册） [11-14岁]",
                        price: 89.00,
                        id: 177928
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/f63e57286a1c4740d01f9a88551eb00c.jpg",
                        title: "少年读史记（全5册 荣获中华优秀出版物奖）[11-14岁]",
                        price: 126.00,
                        id: 177908
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/99ba37a4e91435035aa7c9d08775bd79.jpg",
                        title: "中国香港美心原味鸡蛋卷448g",
                        price: 159.00,
                        id: 169665
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/1751e7d4aaf1e9e2b2c1234e6f8bb775.jpg",
                        title: "轩妈家蛋黄酥4种口味混合各种组合装 发两盒",
                        price: 123.00,
                        id: 169717
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/8f68f65e74c28cfc693511640fa69c9e.jpg",
                        title: "榴芒一刻 榴莲饼200gx2袋装",
                        price: 32.00,
                        id: 177861
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/f225f1c5fe62b64d7924fb49f507e88d.jpg",
                        title: "榴芒一刻 芒果干120gx3袋",
                        price: 43.00,
                        id: 177862
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/14cf7fc33aa6d5f73ee710132d423c03.jpg",
                        title: "榴芒一刻 牛轧奶芙榴莲/芒果/蔓越莓/香橙雪花酥小零食 110gx4袋",
                        price: 53.00,
                        id: 177863
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/00fc8e2b50f1ef495b62dcc17ce46a33.jpg",
                        title: "榴芒一刻 冻干榴莲30g/袋",
                        price: 42.00,
                        id: 177864
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/cf105c13ac625423c2d20aca0891e2e6.jpg",
                        title: "姚生记500克姚小鲜每日坚果/桶装",
                        price: 72.00,
                        id: 177865
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/cac814dbe52a4e29a8da79d293b07112.jpg",
                        title: "小白心里软奶皮白面包450g（5小包，每包2个）",
                        price: 25.00,
                        id: 177866
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/f938e054200a7c92a4481e9b635e0ffc.jpg",
                        title: "小白心里软原味暖暖手撕面420g（9-10包左右）",
                        price: 25.00,
                        id: 177867
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/69a573d4cc3fc1d3cdb89bb27ab7f092.jpg",
                        title: "美心三重奏糕点(礼盒装)331g",
                        price: 195.00,
                        id: 177868
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/7a5431179bb679797ba9001aabdc9118.jpg",
                        title: "美心松脆曲奇饼干272g",
                        price: 125.00,
                        id: 177869
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/4ec5fc63e523413e4a046ef40546ba58.jpg",
                        title: "丹麦蓝罐曲奇饼干年货礼盒454g",
                        price: 75.00,
                        id: 8863
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/47737c3f717e08c67b2a1e8f020d9ddf.jpg",
                        title: "伊利安慕希高端畅饮型希腊风味酸奶原味230gx10",
                        price: 77.00,
                        id: 177870
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/960c89f4fe7ad753b270d63eb3e84c0c.jpg",
                        title: "伊利金典有机纯牛奶梦幻盖 250mlx10盒",
                        price: 74.00,
                        id: 10350
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2020/09/23/632db2d1c3742f316d6cc694174dd9ef.jpg",
                        title: "蒙牛 特仑苏有机纯牛奶250mlx10盒",
                        price: 78.00,
                        id: 155
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/70ad80efd5722b911c021004d73bc805.jpg",
                        title: "聪明小熊四味奶油曲奇320g",
                        price: 118.00,
                        id: 177871
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/a6a9f8eeb201dfaf8e422b355db2ddd0.jpg",
                        title: "萌甜甜原味芝士牛肉卷x3",
                        price: 69.00,
                        id: 177872
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/cb1c89f3bc3f782abd81179f9636fc65.jpg",
                        title: "好丽友吉祥礼礼盒817g",
                        price: 89.00,
                        id: 177873
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/4ef1a42c4971fe7e0c4d79268694db65.jpg",
                        title: "德芙悦享欢聚礼盒684g",
                        price: 116.00,
                        id: 177874
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/0bc4d1ce7e202f2c576d7b9fd2541dd9.jpg",
                        title: "皇冠（danisa）丹麦曲奇饼干681g礼盒装",
                        price: 98.00,
                        id: 177875
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220523/007851ce3740507675456be3131ec209.jpg",
                        title: "三只松鼠 缤纷坚果礼298型升级版/1785g",
                        price: 199.00,
                        id: 178704
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/01/20210105/ec6bd6fdde8e56633840229ec83f43f9.jpg",
                        title: "臻味-2980g环球美果礼盒",
                        price: 239.00,
                        id: 253
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220518/3fed2db50b17f4df6f61e7d2c23c356d.jpg",
                        title: "百草味 奢华礼一桶天下大礼盒1575g",
                        price: 259.00,
                        id: 178480
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/b9452e43ef638968c1a6a70309b039af.jpg",
                        title: "臻味-810g天天坚果儿童款礼盒",
                        price: 145.00,
                        id: 177876
                    }
                    ]
                }
            ],
            navTop: null,
            scrollbar: null,
            leaveScroll: 0,
            current: "" //nav当前id
        }
    },
    mounted: function () {
        let dom = this.$refs.dw;
        this.getData();
        dom.addEventListener("scroll", debounce(this.onScroll, 20), false);
    },
    updated: function () {
        this.getDom();
    },
    methods: {
        goBack() {
            this.$router.push('/');
        },
        checkNav: function (id) {
            // console.log(id, "nav");
            if (id == this.current) return;
            this.current = id;
            const dom = this.$refs.dw;
            for(let i=0; i < this.list.length; i++ ) {
                if (id == this.list[i].id) {
                    dom.scrollTo(0, this.list[i].top);
                }
            }
        },
        goToTop: function () {
            const dom = this.$refs.dw;
            dom.scrollTo(0, 0);
            this.mounting = false;
            this.current = this.list[0].id;
        },
        onScroll: function (e) {
            let scrol = e.target.scrollTop;
            // console.log(scrol,"监听滚动条");
            this.scrollbar = scrol;
            if (this.navTop && scrol >= this.navTop) { // nav
                this.mounting = true;
            } else {
                this.mounting = false;
            }

            this.list.forEach((item)=>{
                if (item.totalHeight >= scrol && scrol >= item.top) {
                    // console.log(item.top,"top", item.totalHeight);
                    this.current = item.id;
                }
            });
        },
        getData: function () {
            //获取数据
            this.current = this.list[0].id;
            //this.$nextTick(()=>)↓
            // this.$nextTick(()=> this.getDom())
            
        },
        getDom: function () {
            // console.log(this.$refs.modul1.offsetHeight, "height")
            this.list.forEach((item)=>{
                item.top = this.$refs[`modul${item.id}`] && this.$refs[`modul${item.id}`][0] && this.$refs[`modul${item.id}`][0].offsetTop;
                item.totalHeight = this.$refs[`modul${item.id}`][0].offsetTop + this.$refs[`modul${item.id}`][0].offsetHeight;
            });
            this.navTop = this.$refs.nav.offsetTop;//555
            // console.log(this.list,"this.list");
        }
    },
    deactivated: function () {
        // let dom = this.$refs.dw;
        // dom.removeEventListener("scroll", this.onScroll);
    },
    activated: function () {
        const dom = this.$refs.dw;
        dom.scrollTo(0, this.scrollbar);
    },
    beforeRouteLeave: function (to, from, next) {
        this.leaveScroll = this.scrollbar;
        next();
    }
}
</script>

<style scoped>
.banner-wrapper {
    height: 13.18rem;
}
.festivalList-wrapper {
    height: auto;
    background: url("../../assets/images/child-background.png") no-repeat;
    background-size: 100% 100%;
}
.nav-content-title-wrapper {
    height: .8rem;
}
.mounting {
    position: fixed;
    top: 0;
    left: 0;
    height: 1.3rem !important;
    background: transparent !important;
}
.nav-wrapper {
    height: 1.6rem;
    background: url("../../assets/images/child-nav-bag.png") no-repeat;
    background-size: 100% 100%;
}

.marTop {
    margin-top: 1rem;
}
.goTop {
    width: 1.3rem;
    height: auto;
}
.goHome {
    width: 1.3rem;
    height: auto;
}
.gowrap {
    bottom: 3.2rem;
    left: 50%;
    transform: translate(-50%, 0);
}
</style>